// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"0f97de6673cc63791593","418":"be461e2a2aca43c600ea"}[chunkId] + ".js";
};